import React from 'react'
import { Link } from 'wouter'
import { usePageTitle } from '../components/common/hooks-utils'
import { ProtocolBadge } from '../components/content/ProtocolBadge'
import { waylandProtocolRegistry } from '../data/protocol-registry'
import { i18n } from '../lib/i18n-labels'
import { useLanguage } from '../lib/LanguageContext'

export const Homepage: React.FC = () => {
    const { language } = useLanguage()
    const labels = i18n[language]
    usePageTitle(labels.homepageTitle)

    return (
        <div className="py-12 lg:py-24 xl:py-32 bg-white dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:text-center">
                    <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
                        Wayland Explorer
                    </h2>
                    <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-white">
                        {labels.homepageSubtitle}
                    </p>
                    <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                        {labels.homepageDescription}
                    </p>
                    <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                        {labels.homepageStartReading}{' '}
                        <Link className="text-indigo-500" href="/wayland">
                            {labels.homepageCoreProtocol}
                        </Link>{' '}
                        {labels.homepageOrDiscover}{' '}
                        <Link
                            className="text-indigo-500"
                            href="/xdg-decoration-unstable-v1"
                            title="XDG decoration"
                        >
                            {labels.homepageUncutGems}
                        </Link>
                        {language === 'zh' ? '。' : '.'}
                    </p>
                </div>
                <div className="mt-12">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {waylandProtocolRegistry.protocols.map((protocol) => (
                            <div
                                key={protocol.id}
                                className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500 dark:bg-gray-800 dark:border-black"
                            >
                                <div className="w-full min-w-0">
                                    <Link href={`/${protocol.id}`}>
                                        <a
                                            href={`/${protocol.id}`}
                                            className="focus:outline-none"
                                        >
                                            <span
                                                className="absolute inset-0"
                                                aria-hidden="true"
                                            />
                                            <div className="flex justify-between items-center">
                                                <div className="text-sm font-medium text-gray-900 dark:text-white">
                                                    {protocol.name}
                                                </div>
                                                <ProtocolBadge
                                                    protocol={protocol}
                                                />
                                            </div>
                                            {protocol.protocol.description
                                                ?.summary && (
                                                <p className="capitalize text-sm text-gray-500 truncate mt-2">
                                                    {
                                                        protocol.protocol
                                                            .description
                                                            ?.summary
                                                    }
                                                </p>
                                            )}
                                        </a>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
